'use client'

import { useEffect, useMemo, useState } from 'react'

function daysUntil(dateIso: string): number {
  return Math.max(0, Math.ceil((new Date(dateIso).getTime() - Date.now()) / (24 * 60 * 60 * 1000)))
}

export function PreseasonHero({ firstMatchDate }: { firstMatchDate: string }) {
  const [days, setDays] = useState(() => daysUntil(firstMatchDate))
  const formattedDate = useMemo(() => new Date(firstMatchDate).toLocaleDateString('it-IT', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }), [firstMatchDate])

  useEffect(() => {
    const timer = window.setInterval(() => setDays(daysUntil(firstMatchDate)), 60_000)
    return () => window.clearInterval(timer)
  }, [firstMatchDate])

  return (
    <section className="relative isolate h-full overflow-hidden rounded-[24px] bg-[color:var(--brand-900)] text-white shadow-[var(--league-shadow-md)] md:rounded-[32px]">
      {/*
       * Trama diagonale statica al posto dei blob sfocati + anello rotante:
       * quelli sono i segnali piu' riconoscibili di una hero "generata".
       */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.12]"
        style={{ backgroundImage: 'repeating-linear-gradient(118deg, rgba(255,255,255,0.55) 0 1px, transparent 1px 20px)' }}
      />
      <div className="relative grid h-full gap-10 px-6 py-8 md:grid-cols-[minmax(0,1fr)_auto] md:items-center md:px-12 md:py-12">
        <div>
          <p className="text-[12px] font-bold uppercase tracking-[0.22em] text-[#f4b400]">Pre-season · Serie C e D maschili</p>
          <h2 className="mt-3 max-w-2xl font-display text-[36px] font-bold leading-[0.95] tracking-[-0.04em] md:text-[56px]">
            Il prossimo set è già nel mirino.
          </h2>
          <p className="mt-4 max-w-xl text-[16px] leading-7 text-white/70 md:text-[16px]">
            La stagione sta per cominciare. Il campo è pronto per il primo appuntamento ufficiale del campionato maschile.
          </p>
        </div>

        <div className="flex items-end gap-6 md:gap-8">
          <div>
            <span className="block font-display text-[64px] font-bold leading-[0.78] tracking-[-0.04em] text-[#f4b400] md:text-[88px]">
              {days}
            </span>
            <span className="mt-2 block text-[12px] font-semibold uppercase tracking-[0.16em] text-white/55">
              {days === 1 ? 'giorno' : 'giorni'} al via
            </span>
          </div>
          <div className="border-l border-white/15 pb-1 pl-6 text-[14px] font-semibold text-white/60">
            Prima partita
            <span className="mt-1 block max-w-[190px] capitalize text-white">{formattedDate}</span>
          </div>
        </div>
      </div>
    </section>
  )
}
